<template>
  <v-container>
    <v-row v-if="!selectedPlacementId">
      <!-- Placements Table -->
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="placements || []"
              :items-per-page="itemsPerPage"
              :loading="loading"
              height="400px"
              fixed-header
              hover
              :page="page"
              :items-per-page-options="[5, 10, 20]"
              :items-length="placements ? Object.keys(placements).length : 0"
              :server-items-length="
                placements ? Object.keys(placements).length : 0
              "
              must-sort
            >
              <template v-slot:item="{ item }">
                <tr @click="handleRowClick(item)" class="cursor-pointer">
                  <td>{{ item }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

defineProps<{
  accountId?: string
  placements: string[]
  loading: boolean
}>()

const emit = defineEmits<{
  'update:placementId': [placementId: string]
}>()

const itemsPerPage = ref(5)
const page = ref(1)
const selectedPlacementId = ref<string | null>(null)

interface TableHeader {
  title: string
  key: string
  align: 'start' | 'end' | 'center'
  value: string
}

const tableHeaders: TableHeader[] = [
  {
    title: 'Placement Name',
    key: 'name',
    align: 'start' as const,
    value: 'name',
  },
]

const handleRowClick = (row: any) => {
  selectedPlacementId.value = row
  emit('update:placementId', row)
}

onMounted(() => {
  //
})
</script>

<style scoped>
:deep(.v-skeleton-loader__chip) {
  height: 25px;
  margin: 0 !important;
}
:deep(.v-skeleton-loader__text) {
  height: 19px;
  margin: 0 !important;
}
.compared-data__value-title {
  color: #666;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.75;
}
.compared-data__value {
  font-size: 2.5em;
  font-weight: bold;
  line-height: 1em;
  margin-top: 2px;
}
.compared-data__value-skeleton {
  margin-top: 6px;
}
.compared-data__stat {
  margin-top: 10px;
}
.compared-data__stat-skeleton {
  margin-top: 16px;
}
</style>
